import { memo } from 'react'
import { sanitizeHTML } from 'src/utils/sanitizeHTML'

import './styles.scss'
import GenericCarousel from './Carousel/GenericCarousel'

type ProductDescriptionProps = {
  contentOne: string
}

const ProductDescriptionCarousel = ({
  contentOne,
}: ProductDescriptionProps) => {
  return (
    <>
      {contentOne && (
        <div className="productDescriptionCarouselContainer">
          <GenericCarousel title="Características">
            <article
              data-testid="productDescription"
              className="productDescription
                  w-full
                  flex flex-row bg-white items-center
                  justify-between pb-4 pt-8 text-neutral06 text-sm font-medium"
            >
              <div
                className="flex flex-row gap-3"
                suppressHydrationWarning
                dangerouslySetInnerHTML={{
                  __html: sanitizeHTML(contentOne),
                }}
              />
            </article>
          </GenericCarousel>
        </div>
      )}
    </>
  )
}

export default memo(ProductDescriptionCarousel)
